var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "图片裁剪",
        "append-to-body": true,
        visible: _vm.visible,
        width: "1000px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.closeImageClipping,
      },
    },
    [
      _c("div", { staticClass: "qm-image-clipping" }, [
        _c("div", { staticClass: "qm-image-clipping-preview" }, [
          _c("div", { staticClass: "qm-image-clipping-size" }, [
            _c(
              "div",
              { staticClass: "qm-image-clipping-size_content" },
              _vm._l(_vm.sizeThanColumn, function (item) {
                return _c(
                  "div",
                  {
                    key: item.type,
                    class: {
                      "qm-size-column-active": item.type == _vm.currentSize,
                    },
                    on: {
                      click: function ($event) {
                        _vm.chooseTheSize(item)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "qm-size-column-name" }, [
                      _vm._v(_vm._s(item.size)),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
          _c(
            "div",
            { staticClass: "qm-operation-btn" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.pluginExe("cropPicture")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]),
        _vm.refresh
          ? _c(
              "div",
              [
                _c(
                  "ImgCutter",
                  {
                    ref: "imgCutterModal",
                    attrs: {
                      "cross-origin": _vm.params.crossOrigin,
                      label: _vm.params.label,
                      rate: _vm.params.rate,
                      index: _vm.params.index,
                      "is-modal": _vm.params.isModal,
                      "show-choose-btn": _vm.params.showChooseBtn,
                      "lock-scroll": _vm.params.lockScroll,
                      "box-width": _vm.params.boxWidth,
                      "box-height": _vm.params.boxHeight,
                      "cut-width": _vm.params.cutWidth,
                      "cut-height": _vm.params.cutHeight,
                      "size-change": _vm.params.sizeChange,
                      "move-able": _vm.params.moveAble,
                      "img-move": _vm.params.imgMove,
                      tool: _vm.params.tool,
                      "file-type": _vm.params.fileType,
                      "original-graph": _vm.params.originalGraph,
                      "preview-mode": _vm.params.previewMode,
                      "tool-box-overflow": _vm.params.toolBoxOverflow,
                      "small-to-upload": _vm.params.smallToUpload,
                      "save-cut-position": _vm.params.saveCutPosition,
                      "scale-able": _vm.params.scaleAble,
                      "do-not-display-copyright": true,
                      "tool-bgc": "params.toolBgc",
                    },
                    on: { cutDown: _vm.cutDown },
                  },
                  [
                    _vm.params.isModal == false
                      ? _c("span", {
                          attrs: { slot: "choose" },
                          slot: "choose",
                        })
                      : _vm._e(),
                    _vm.params.isModal == false
                      ? _c("span", {
                          attrs: { slot: "cancel" },
                          slot: "cancel",
                        })
                      : _vm._e(),
                    _vm.params.isModal == false
                      ? _c("span", {
                          attrs: { slot: "confirm" },
                          slot: "confirm",
                        })
                      : _vm._e(),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }